module.exports = __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLGT9Z1xlFd2JQEk.a09f2fcc.woff2";